import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import classnames from 'classnames';

import { AppHeaderAdmin, AppHeaderDefault, BaseButtonFill } from 'bxcommon';
import { clearForm } from '../../store/slices/request.slice';

import './AdvisorHeader.scss';

export const AdvisorHeader = ({ children, hideControls }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const isAdmin = useSelector((state) => state.user.details.is_admin);

  const goToForm = () => {
    dispatch(clearForm());
    navigate('/request-form');
  };

  const header = (
    <div
      className={classnames('advisor-header', {
        'advisor-header--admin': isAdmin && !hideControls,
      })}
    >
      {isAdmin && !hideControls ? (
        <BaseButtonFill
          type="button"
          iconRight
          icon="add"
          onClick={goToForm}
          data-testid="advisor-header-admin-add-new"
        >
          {t('header.createNew')}
        </BaseButtonFill>
      ) : (
        <div className="advisor-header__title">{t('header.name')}</div>
      )}
    </div>
  );

  return (
    <AppHeaderDefault isAdvisor hideControls={hideControls} adminHeader={<AppHeaderAdmin />} controls={header}>
      {children}
    </AppHeaderDefault>
  );
};

export default AdvisorHeader;
